import store from '../stores/configureStore'

export function getSessionDataPayload() {
  const {
    recipient,
    transaction,
    unilateral,
    crossBorder,
    server,
  } = store.getState()
  const { typedRecipient = '' } = recipient
  const {
    hasSeenNote = false,
    dcFlow = '',
    pendingResolutions = [],
    selectedPurposeOfPaymentOption = '',
    consolidatedFlowIntent,
  } = transaction
  const { unilateralFirstName = '', unilateralLastName = '' } = unilateral

  const {
    toCurrencyCode = '',
    fromCurrencyCode = '',
    rate = '',
    originAmount = '',
  } = crossBorder
  const { env = '' } = server

  return {
    typedRecipient,
    hasSeenNote,
    dcFlow,
    pendingResolutions,
    unilateralFirstName,
    unilateralLastName,
    editableFields: transaction.editableFields,
    selectedPurposeOfPaymentOption,
    consolidatedFlowIntent,
    toCurrencyCode,
    fromCurrencyCode,
    rate,
    originAmount,
    env,
  }
}
